import Link from '@ui/Link';
import Typography from '@ui/Typography';
import { getEndsInText } from '@utils/dateHelpers';
import {
  getPostImage,
  getPostLink,
  getVolunteeringPostLink,
  shouldDisablePostCauses,
} from '@utils/post.helper';
import React from 'react';
import ActionBar from './ActionBar';
import NonProfitCauses from './NonProfitCauses';
import PostAuthorProfile from './PostAuthorProfile';
import PostImage from './PostImage';
import PostMessage from './PostMessage';
import PostTypeIndicatorChip from './PostTypeIndicatorChip';
import PostVideo from './PostVideo';
import ReactionBar from './ReactionBar';
import VolunteeringLocationAndTime from './VolunteeringLocationAndTime';
import VolunteeringProgress from './VolunteeringProgress';
import OrgType from '@/constants/orgType.constant';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import NonProfitProfileBar from './NonProfitProfileBar';
import PostImageLink from './PostImageLink';

function VolunteeringPostBody(props) {
  const { post, type, home, orgSlug = null } = props;
  const { sourcePostData } = post;
  const { volunteerOpportunity } = sourcePostData;
  const nonProfit = post.renderProps.nonProfit;
  const { name, description, endsOn } = volunteerOpportunity;

  const endsInDaysText = getEndsInText(endsOn);

  const hasImage = getPostImage(post);
  const hasVideo = post.renderProps.videoUrls && post.renderProps.videoUrls[0];
  let slug = post.renderProps?.company?.name.toLowerCase().replace(/\s+/g, '-');

  slug =
    post.renderProps?.company?.orgType === OrgType.NonProfit
      ? `nonprofit/${slug}`
      : `company/${slug}`;

  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);
  const postLink = getPostLink(post);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div>
        <div className="divide-y px-6 lg:px-4">
          <div className="flex flex-col gap-4 py-6 lg:py-4">
            {!disablePostCauses && nonProfit && nonProfit.causes && (
              <NonProfitCauses
                nonProfit={nonProfit}
                className="border-b pb-4"
              />
            )}

            <PostAuthorProfile post={post} home={home} orgSlug={orgSlug} />
          </div>

          <div className="flex w-full flex-col items-start justify-between gap-2 py-2 lg:flex-row">
            <Link href={postLink}>
              <Typography
                variant="h5"
                className="flex-1 group-hover:text-text-hyperlink">
                {name}
              </Typography>
            </Link>
            <div className="flex w-full items-center justify-between gap-2 lg:w-auto lg:flex-col lg:items-end">
              <PostTypeIndicatorChip postType={post.sourcePostType} />
              <Typography
                variant="caption"
                color="textSecondary"
                className="whitespace-nowrap">
                {endsInDaysText}
              </Typography>
            </div>
          </div>
        </div>

        {hasVideo ? (
          <PostVideo post={post} />
        ) : (
            <PostImageLink post={post} />
        )}
        
        {nonProfit && <NonProfitProfileBar nonProfit={nonProfit} post={post} />}

        <div className="flex flex-col gap-6 px-6 lg:px-4">
          <div className="flex flex-col items-stretch justify-start gap-4 pt-6">
            <VolunteeringProgress post={post} className="w-full" />
            <VolunteeringLocationAndTime post={post} />
          </div>

          <div className="divide-y">
            <div className="py-2">
              <PostMessage message={description} />
            </div>

            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} orgSlug={orgSlug} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default VolunteeringPostBody;
